<template>
  <div class="goods-group-edit">
    <common-dialog
      ref="dialog"
      title="Edit Goods Group"
      :inputs-map="groupInfo"
      :input-value-change="valueChange"
      :save-cb="dialogSaveCb"
      :reset-inputs="resetInputs"
      :width="40"
    >
      <template v-slot:buttons>
        <div class="extra-btns f-r">
          <div class="op confirm" @click="addAddress" v-if="!hasAddress">
            <svg-icon
              icon-class="plus"
              style="font-size: 20px;"
              class="svg-business-color"
            />
            <span>Add Address</span>
          </div>
        </div>
      </template>
    </common-dialog>
    <address-new ref="newAddress"></address-new>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'
// models
import { GoodsGroupForm } from '@/core/models/job'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
import AddressNew from '@/components/address/AddressNew.vue'
export default {
  name: 'GoodsGroupEdit',
  components: {
    CommonDialog,
    AddressNew
  },
  data() {
    return {
      groupInfo: cloneDeep(GoodsGroupForm),
      initialValues: null,
      saveCb: null
    }
  },
  computed: {
    hasAddress() {
      const addressInfo = this.groupInfo.find(g => g.key === 'address')
      return !!addressInfo.value
    }
  },
  methods: {
    open(initialValues, saveCb = null) {
      this.initialValues = initialValues
      this.$refs.dialog.open()
      this.saveCb = saveCb
    },
    dialogSaveCb(form, done, error) {
      form.addressId = form.address?.id ?? undefined
      delete form.address
      this.saveCb(form, done, error)
    },
    valueChange(key, val) {
      if (key === 'address') {
        this.groupInfo[1].value = val.code
      }
    },
    resetInputs() {
      this.$set(this.groupInfo[0], 'value', this.initialValues?.address)
      this.$set(this.groupInfo[1], 'value', this.initialValues?.name ?? '')
    },
    close() {
      this.$refs.dialog.close()
    },
    addAddress() {
      this.$refs.newAddress.open()
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.op {
  gap: 5px;

  &:hover {
    cursor: pointer;
  }

  @extend .f-r-vc;

  span {
    font-size: $title-level-regular;
  }

  .op-icon {
    font-size: 26px;
    filter: $svg-business-color;
  }
}
</style>
